export default __webpack_public_path__ + "static/media/logo_white.39ff4f91.png";